import React from 'react';

import { IconTypes } from '@eika/icon';
import { ListPanel } from '@eika/link-panel';

import useText from '@/hooks/use-text';
import piwik from '@/piwik/piwik';

interface OrderNewDebitCardPanelProps {
    orderNewDebitCardUrl: string | undefined;
}

export const OrderNewDebitCardPanel = ({ orderNewDebitCardUrl }: OrderNewDebitCardPanelProps) => {
    const { orderCardBankCardOption, orderCardBankCardDescription } = useText();

    if (typeof orderNewDebitCardUrl === 'undefined') {
        return null;
    }

    return (
        <ListPanel
            as="li"
            data-track-id={piwik?.cardOverview?.cardOrderOptionLinkOrderDebitCard?.dataTrackId}
            data-track-linkname={piwik?.cardOverview?.cardOrderOptionLinkOrderDebitCard?.dataTrackLinkname}
            id={piwik?.cardOverview?.cardOrderOptionLinkOrderDebitCard?.dataTrackId}
            icon={IconTypes.PLUSS_24}
            invertIcon
            backgroundColor="light"
            title={orderCardBankCardOption}
            textTwo={orderCardBankCardDescription}
            url={orderNewDebitCardUrl}
        />
    );
};
